import React from 'react';
import { useUI } from './useUI';
import { ModalData, ModalID } from '../index';

export const zIndexes = ['tw-z-[2000]', 'tw-z-[2100]', 'tw-z-[2200]', 'tw-z-[2300]', 'tw-z-[2400]'];

export const useModal = <ID extends ModalID>(id: ID) => {
  const { openModalIds, openModalsMap, closeModal, pushModal, enableID, disableID } = useUI();
  const index = openModalIds?.indexOf(id);
  const _data: ModalData[ID] = openModalsMap?.get(id);
  const [data, setData] = React.useState(_data);

  React.useEffect(() => {
    setData(_data);
  }, [_data]);

  const close = React.useCallback(() => closeModal(id), [closeModal, id]);
  const closeAll = React.useCallback(() => {
    openModalIds?.forEach(closeModal);
  }, [closeModal, openModalIds]);
  const push = React.useCallback(
    (...args: ModalData[ID] extends void ? [] : [ModalData[ID]]) =>
      // @ts-expect-error typescript can't figure this out
      pushModal(id, args[0]),
    [pushModal, id],
  );
  const enable = React.useCallback(() => enableID(id), [enableID, id]);
  const disable = React.useCallback(() => disableID(id), [disableID, id]);
  const isTopModal = openModalIds?.length > 0 && openModalIds[openModalIds.length - 1] === id;

  return {
    index,
    active: index !== -1,
    close,
    closeAll,
    isTopModal,
    push,
    data,
    zIndex: zIndexes[index !== -1 ? index : (openModalIds?.length ?? 0)],
    enable,
    disable,
  };
};
